import { render, staticRenderFns } from "./FormZones.vue?vue&type=template&id=114a3d65&scoped=true&"
import script from "./FormZones.vue?vue&type=script&lang=ts&"
export * from "./FormZones.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "114a3d65",
  null
  
)

export default component.exports